// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"ReservationList--next-sr-only--28Khat3","pageContainer":"ReservationList--pageContainer--3OtoJrg"};